const main= (to,next,redirect)=>{
 //verify login pages
 if (to.matched.some(i => i.meta.loginRequired)) {
  let user= localStorage.getObject('user');
  let message= encodeURIComponent(`You need to be logged in to access the requested resource.`);
  //check if the user is logged in
  if ( user && user.id!==null && user.id!==undefined && user.token!==null && user.token!==undefined ){ return next(); }
  next({
    path: redirect,
    query:{ message, route:to.fullPath }
  });
}
else{ next(); }
};
export default main;